import classNames from 'classnames';
import './RadioButton.scss';

import {
  ChangeEventHandler,
  KeyboardEventHandler,
  MouseEventHandler,
} from 'react';

interface Props {
  group: string;
  label: string;
  isChecked: boolean;
  'data-testid'?: string;
  value: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  onClick: ChangeEventHandler<HTMLInputElement>;
  onClickLabel?: MouseEventHandler<HTMLLabelElement>;
  onKeyDownLabel?: KeyboardEventHandler<HTMLLabelElement>;
}

const className = 'c-RadioButton';

const RadioButton = ({
  label,
  onClick,
  isChecked,
  'data-testid': dataTestId,
  value,
  group,
  disabled,
  icon,
  onClickLabel,
  onKeyDownLabel,
}: Props) => {
  return (
    <div className={className}>
      <label
        className={`${className}__label`}
        onClick={onClickLabel}
        onKeyDown={onKeyDownLabel}
        tabIndex={0}
      >
        <input
          type="radio"
          className={`${className}__input`}
          name={group}
          data-testid={dataTestId}
          value={value}
          checked={isChecked}
          disabled={disabled}
          onChange={onClick}
        />
        <span
          className={classNames(`${className}__text`, {
            [`${className}__text--checked`]: isChecked,
          })}
        >
          {label}
        </span>
        <div className={`${className}__icon`}>{icon}</div>
      </label>
    </div>
  );
};

export default RadioButton;
